export default __webpack_public_path__ + "static/media/SourceSansPro-Italic.df0284f4.woff2";